module.exports = __webpack_public_path__ + "img/tabBar_1@3x.ae6d8bab.png";